<h4 class="mb-0">{{translate.getLng('ROOF_HOOK')}}</h4>
<div class="position-relative" fxLayout="row" fxLayoutAlign="flex-start center">
    <mat-form-field>
        <mat-label>{{translate.getLng('RH_SUPP_SHAFT')}}</mat-label>
        <mat-select [(ngModel)]="rbTypeVario">
            <mat-option [value]="rbTypeVarioDuo">
                {{translate.getLng('SD_VARIO_DUO')}}
            </mat-option>
            <mat-option [value]="rbTypeVarioSolo">
                {{translate.getLng('SD_VARIO_SOLO')}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-icon (click)="getVarioItemDesc(varioPopUp)" [autoClose]="'outside'" triggers="manual" #varioPopUp="ngbPopover"
        [ngbPopover]="varioInformation" placement="left" class="sen-cursor-pointer">
        info
    </mat-icon>
</div>
<ng-template #varioInformation>
    <mat-tab-group animationDuration="0ms" class="px-3 sen-submenu-color">
        <mat-tab *ngIf="varioItemDescriptionDuo" label="{{translate.getLng('SD_VARIO_DUO')}}">
            <div fxLayout="row" fxLayoutAlign="center center">
                <div>
                    <img src="{{varioItemDescriptionDuo.ok.data.imageURL}}">
                </div>
                <pre>{{varioItemDescriptionDuo.ok.data.description}}</pre>
            </div>
        </mat-tab>
        <mat-tab *ngIf="varioItemDescriptionSolo" label="{{translate.getLng('SD_VARIO_SOLO')}}">
            <div fxLayout="row" fxLayoutAlign="center center">
                <div>
                    <img src="{{varioItemDescriptionSolo.ok.data.imageURL}}">
                </div>
                <pre>{{varioItemDescriptionSolo.ok.data.description}}</pre>
            </div>
        </mat-tab>
    </mat-tab-group>
</ng-template>
<div fxLayout="row" fxLayoutAlign="flex-start center">
    <mat-form-field>
        <mat-label>{{translate.getLng('BASE_PLATE')}}</mat-label>
        <mat-select [(ngModel)]="rbBasePlate">
            <mat-option [value]="rbBasePlateBig">
                {{translate.getLng('BASE_PLATE_BIG')}}
            </mat-option>
            <mat-option [value]="rbBasePlateMixed">
                {{translate.getLng('BASE_PLATE_MIXED')}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-icon (click)="getShaftItemDesc(shaftPopUp)" [autoClose]="'outside'" triggers="manual" #shaftPopUp="ngbPopover"
        [ngbPopover]="shaftInformation" placement="left" matSuffix class="sen-cursor-pointer">info</mat-icon>
</div>
<ng-template #shaftInformation>
    <mat-tab-group animationDuration="0ms" class="px-3 sen-submenu-color">
        <mat-tab *ngIf="plateItemDescriptionBig" label="{{translate.getLng('BASE_PLATE_BIG')}}">
            <div fxLayout="row" fxLayoutAlign="center center">
                <div class="mr-3">
                    <img src="{{plateItemDescriptionBig.ok.data.imageURL}}">
                </div>
                <pre>{{plateItemDescriptionBig.ok.data.description}}</pre>
            </div>
        </mat-tab>
        <mat-tab *ngIf="plateItemDescriptionSmall" label="{{translate.getLng('BASE_PLATE_MIXED')}}">
            <div *ngIf="plateItemDescriptionBig" fxLayout="row" fxLayoutAlign="center center">
                <div class="mr-3">
                    <img src="{{plateItemDescriptionBig.ok.data.imageURL}}">
                </div>
                <pre>{{plateItemDescriptionBig.ok.data.description}}</pre>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center">
                <div class="mr-3">
                    <img src="{{plateItemDescriptionSmall.ok.data.imageURL}}">
                </div>
                <pre>{{plateItemDescriptionSmall.ok.data.description}}</pre>
            </div>
        </mat-tab>
    </mat-tab-group>
</ng-template>
<hr class="border-white">